import { render, staticRenderFns } from "./Vipps.vue?vue&type=template&id=0539183a&scoped=true&"
import script from "./Vipps.vue?vue&type=script&lang=js&"
export * from "./Vipps.vue?vue&type=script&lang=js&"
import style0 from "./Vipps.vue?vue&type=style&index=0&id=0539183a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0539183a",
  null
  
)

export default component.exports